import * as React from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Toolbar from '@mui/material/Toolbar';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

import './App.css';
import Header from './components/Header';
// import HomePage from './pages/HomePage';
// import APITestPage from './pages/APITestPage';
import LoginPage from './pages/LoginPage';
import TokenUnavailablePage from './pages/TokenUnavailablePage';
import DashboardPage from './pages/DashboardPage';
import SpecificationPage from './pages/SpecificationPage';
import IMEIPage from './pages/IMEIPage';
import CheckOrderInfoPage from './pages/CheckOrderInfoPage';
// Deprecated 2022/10/26
// import CheckAppearancePage from './pages/CheckAppearancePage';
// import CheckAppearanceSubPage from './pages/CheckAppearanceSubPage';
import AgreementConfirmationPage from './pages/AgreementConfirmationPage';
import SignAgreementPage from './pages/SignAgreementPage';
import ClientInfoPage from './pages/ClientInfoPage';
import CheckPDFPage from './pages/CheckPDFPage';
import MobileVerifyPage from './pages/MobileVerifyPage';
import ClientSignPage from './pages/ClientSignPage';
import AgentSignPage from './pages/AgentSignPage';
import StoreSignPage from './pages/StoreSignPage';
import CheckOrderInfoAgainPage from './pages/CheckOrderInfoAgainPage';
// Deprecated 2022/10/26
// import QRCodeForStorePage from './pages/QRCodeForStorePage';
import OrderCompletedPage from './pages/OrderCompletedPage';
import CheckPDFAgainPage from './pages/CheckPDFAgainPage';
import TapPayPage from './pages/TapPayPage';
import BarcodePage from './pages/BarcodePage';
import QueryPreviousOrderPage from './pages/QueryPreviousOrderPage';
import SelectPreviousOrderPage from './pages/SelectPreviousOrderPage';
import UploadPhotosPage from './pages/UploadPhotosPage';
import SelectInstallmentPage from './pages/SelectInstallmentPage';
import BankTransferInfoPage from './pages/BankTransferInfoPage';
// burglary insurance
import BICheckPage from './pages/burglary-insurance/CheckPage';
import BISpecificationPage from './pages/burglary-insurance/SpecificationPage';
import BICheckOrderInfoPage from './pages/burglary-insurance/CheckOrderInfoPage';
import BIAgreementConfirmationPage from './pages/burglary-insurance/AgreementConfirmationPage';
import BISignAgreementPage from './pages/burglary-insurance/SignAgreementPage';
import BIClientInfoPage from './pages/burglary-insurance/ClientInfoPage';
import BIMobileVerifyPage from './pages/burglary-insurance/MobileVerifyPage';
import BICheckPDFPage from './pages/burglary-insurance/CheckPDFPage';
import BIClientSignPage from './pages/burglary-insurance/ClientSignPage';
import BIAgentSignPage from './pages/burglary-insurance/AgentSignPage';
import BIStoreSignPage from './pages/burglary-insurance/StoreSignPage';
import BICheckOrderInfoAgainPage from './pages/burglary-insurance/CheckOrderInfoAgainPage';
import BICheckPDFAgainPage from './pages/burglary-insurance/CheckPDFAgainPage';
import BIUploadPhotosPage from './pages/burglary-insurance/UploadPhotosPage';
import BIOrderCompletedPage from './pages/burglary-insurance/OrderCompletedPage';
// extend new
import ENCheckPage from './pages/extend-new/CheckPage';
import ENSpecificationPage from './pages/extend-new/SpecificationPage';
import ENCheckOrderInfoPage from './pages/extend-new/CheckOrderInfoPage';
import ENAgreementConfirmationPage from './pages/extend-new/AgreementConfirmationPage';
import ENClientInfoPage from './pages/extend-new/ClientInfoPage';
import ENMobileVerifyPage from './pages/extend-new/MobileVerifyPage';
import ENSignAgreementPage from './pages/extend-new/SignAgreementPage';
import ENTapPayPage from './pages/extend-new/TapPayPage';
import ENUploadPhotosPage from './pages/extend-new/UploadPhotosPage';
import ENOrderCompletedPage from './pages/extend-new/OrderCompletedPage';
import ENPaymentValidationPage from './pages/extend-new/PaymentValidationPage.jsx';
import ENPaymentFailPage from './pages/extend-new/PaymentFailPage.jsx';

import RequireAuth from './hoc/RequireAuth';
import { Context } from './context/DataContext';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetDataContext, loginByToken, setTokenAttempted } = React.useContext(Context);
  const [checkingToken, setCheckingToken] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get('t');
    if (location.pathname === '/' && t) {
      // Mark that a token login was attempted so Header can adjust UI even on failure
      setTokenAttempted(true);
      setCheckingToken(true);
      loginByToken({ token: t }, (data) => {
        setCheckingToken(false);
        const { rtnObj: { ResponseCode, Attribute4 } = {} } = data || {};

        if (ResponseCode === '1' && Attribute4) {
          navigate('/dashboard', { replace: true });
        } else {
          // On token login failure navigate to a dedicated "Token Unavailable" page
          navigate('/token-unavailable', { replace: true });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  return (
    <div className="App">
      <Header
        handleLogout={() => {
          resetDataContext({}, () => {
            navigate('/login');
          });
        }}
      />
      <Toolbar />
      {checkingToken && <LinearProgress />}
      {checkingToken ? (
        <Box sx={{ textAlign: 'center', pt: 4 }}>檢查登入中...</Box>
      ) : (
        <Routes>
          <Route path="/">
            <Route index element={<Navigate to="/login" replace />} />
            {/* <Route index element={<HomePage />} /> */}
            {/* <Route path="api-test" element={<APITestPage />} /> */}
            <Route path="login" element={<LoginPage />} />
            <Route path="token-unavailable" element={<TokenUnavailablePage />} />
            <Route
              path="dashboard"
              element={
                <RequireAuth>
                  <DashboardPage />
                </RequireAuth>
              }
            />
            <Route
              path="specification"
              element={
                <RequireAuth>
                  <SpecificationPage />
                </RequireAuth>
              }
            />
            <Route
              path="imei"
              element={
                <RequireAuth>
                  <IMEIPage />
                </RequireAuth>
              }
            />
            <Route
              path="check-order-info"
              element={
                <RequireAuth>
                  <CheckOrderInfoPage />
                </RequireAuth>
              }
            />
            {/* // Deprecated 2022/10/26
          <Route path="check-appearance" element={<CheckAppearancePage />}>
            <Route path=":questionId" element={<CheckAppearanceSubPage />} />
          </Route> */}
            <Route
              path="agreement-confirmation"
              element={
                <RequireAuth>
                  <AgreementConfirmationPage />
                </RequireAuth>
              }
            />
            <Route
              path="sign-agreement"
              element={
                <RequireAuth>
                  <SignAgreementPage />
                </RequireAuth>
              }
            />
            <Route
              path="client-info"
              element={
                <RequireAuth>
                  <ClientInfoPage />
                </RequireAuth>
              }
            />
            <Route
              path="check-pdf"
              element={
                <RequireAuth>
                  <CheckPDFPage />
                </RequireAuth>
              }
            />
            <Route
              path="mobile-verify"
              element={
                <RequireAuth>
                  <MobileVerifyPage />
                </RequireAuth>
              }
            />
            <Route
              path="client-sign"
              element={
                <RequireAuth>
                  <ClientSignPage />
                </RequireAuth>
              }
            />
            <Route
              path="agent-sign"
              element={
                <RequireAuth>
                  <AgentSignPage />
                </RequireAuth>
              }
            />
            <Route
              path="store-sign"
              element={
                <RequireAuth>
                  <StoreSignPage />
                </RequireAuth>
              }
            />
            <Route
              path="check-order-info-again"
              element={
                <RequireAuth>
                  <CheckOrderInfoAgainPage />
                </RequireAuth>
              }
            />
            {/* // Deprecated 2022/10/26
          <Route path="qrcode-for-store" element={<QRCodeForStorePage />} /> */}
            <Route path="order-completed" element={<OrderCompletedPage />} />
            <Route
              path="check-pdf-again"
              element={
                <RequireAuth>
                  <CheckPDFAgainPage />
                </RequireAuth>
              }
            />
            <Route
              path="bank-transfer-info"
              element={
                <RequireAuth>
                  <BankTransferInfoPage />
                </RequireAuth>
              }
            />
            <Route
              path="tap-pay"
              element={
                <RequireAuth>
                  <TapPayPage />
                </RequireAuth>
              }
            />
            <Route
              path="select-installment"
              element={
                <RequireAuth>
                  <SelectInstallmentPage />
                </RequireAuth>
              }
            />
            <Route
              path="barcode"
              element={
                <RequireAuth>
                  <BarcodePage />
                </RequireAuth>
              }
            />
            <Route
              path="query-previous-order"
              element={
                <RequireAuth>
                  <QueryPreviousOrderPage />
                </RequireAuth>
              }
            />
            <Route
              path="select-previous-order"
              element={
                <RequireAuth>
                  <SelectPreviousOrderPage />
                </RequireAuth>
              }
            />
            <Route
              path="upload-photos"
              element={
                <RequireAuth>
                  <UploadPhotosPage />
                </RequireAuth>
              }
            />
            <Route path="burglary-insur">
              <Route
                path="check"
                element={
                  <RequireAuth>
                    <BICheckPage />
                  </RequireAuth>
                }
              />
              <Route
                path="spec"
                element={
                  <RequireAuth>
                    <BISpecificationPage />
                  </RequireAuth>
                }
              />
              <Route
                path="check-order-info"
                element={
                  <RequireAuth>
                    <BICheckOrderInfoPage />
                  </RequireAuth>
                }
              />
              <Route
                path="agreement-confirm"
                element={
                  <RequireAuth>
                    <BIAgreementConfirmationPage />
                  </RequireAuth>
                }
              />
              <Route
                path="sign-agreement"
                element={
                  <RequireAuth>
                    <BISignAgreementPage />
                  </RequireAuth>
                }
              />
              <Route
                path="client-info"
                element={
                  <RequireAuth>
                    <BIClientInfoPage />
                  </RequireAuth>
                }
              />
              <Route
                path="mobile-verify"
                element={
                  <RequireAuth>
                    <BIMobileVerifyPage />
                  </RequireAuth>
                }
              />
              <Route
                path="check-pdf"
                element={
                  <RequireAuth>
                    <BICheckPDFPage />
                  </RequireAuth>
                }
              />
              <Route
                path="client-sign"
                element={
                  <RequireAuth>
                    <BIClientSignPage />
                  </RequireAuth>
                }
              />
              <Route
                path="agent-sign"
                element={
                  <RequireAuth>
                    <BIAgentSignPage />
                  </RequireAuth>
                }
              />
              <Route
                path="store-sign"
                element={
                  <RequireAuth>
                    <BIStoreSignPage />
                  </RequireAuth>
                }
              />
              <Route
                path="check-order-info-again"
                element={
                  <RequireAuth>
                    <BICheckOrderInfoAgainPage />
                  </RequireAuth>
                }
              />
              <Route
                path="check-pdf-again"
                element={
                  <RequireAuth>
                    <BICheckPDFAgainPage />
                  </RequireAuth>
                }
              />
              <Route
                path="upload-photos"
                element={
                  <RequireAuth>
                    <BIUploadPhotosPage />
                  </RequireAuth>
                }
              />
              <Route path="order-completed" element={<BIOrderCompletedPage />} />
            </Route>
            <Route path="extend-new">
              <Route
                path="check"
                element={
                  <RequireAuth>
                    <ENCheckPage />
                  </RequireAuth>
                }
              />
              <Route
                path="spec"
                element={
                  <RequireAuth>
                    <ENSpecificationPage />
                  </RequireAuth>
                }
              />
              <Route
                path="check-order-info"
                element={
                  <RequireAuth>
                    <ENCheckOrderInfoPage />
                  </RequireAuth>
                }
              />
              <Route
                path="agreement-confirm"
                element={
                  <RequireAuth>
                    <ENAgreementConfirmationPage />
                  </RequireAuth>
                }
              />
              <Route
                path="client-info"
                element={
                  <RequireAuth>
                    <ENClientInfoPage />
                  </RequireAuth>
                }
              />
              <Route
                path="mobile-verify"
                element={
                  <RequireAuth>
                    <ENMobileVerifyPage />
                  </RequireAuth>
                }
              />
              <Route
                path="sign-agreement"
                element={
                  <RequireAuth>
                    <ENSignAgreementPage />
                  </RequireAuth>
                }
              />
              <Route
                path="tap-pay"
                element={
                  <RequireAuth>
                    <ENTapPayPage />
                  </RequireAuth>
                }
              />
              <Route path="upload-photos" element={<ENUploadPhotosPage />} />
              <Route path="order-completed" element={<ENOrderCompletedPage />} />
              <Route path="payment/:orderId/validation" element={<ENPaymentValidationPage />} />
              <Route path="payment/:orderId/fail" element={<ENPaymentFailPage />} />
            </Route>
          </Route>
        </Routes>
      )}
    </div>
  );
}

export default App;
